var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<header><header-primary><header-title>{{ 'accountSettings' | translateState }}</header-title></header-primary></header><div class=\"o-wrapper\"><gg-tabs><gg-tab name=\"profile\" label=\"{{ 'settings' | translateWith:'profile' }}\"><account-settings-user-edit></account-settings-user-edit></gg-tab><gg-tab ng-if=\"vm.user.game_developer_ids\" name=\"gameDeveloper\" label=\"{{ 'settings' | translateWith:'gameDeveloper' }}\"><account-settings-game-dev-edit></account-settings-game-dev-edit></gg-tab></gg-tabs></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/account/settings/settings.jade
 ** module id = 613
 ** module chunks = 0
 **/